/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatrixCareLookupItem } from './MatrixCareLookupItem';
import {
    MatrixCareLookupItemFromJSON,
    MatrixCareLookupItemFromJSONTyped,
    MatrixCareLookupItemToJSON,
    MatrixCareLookupItemToJSONTyped,
} from './MatrixCareLookupItem';

/**
 * 
 * @export
 * @interface SearchMatrixCareHomeHealthOrganizations200Response
 */
export interface SearchMatrixCareHomeHealthOrganizations200Response {
    /**
     * 
     */
    data?: Array<MatrixCareLookupItem>;
}

/**
 * Check if a given object implements the SearchMatrixCareHomeHealthOrganizations200Response interface.
 */
export function instanceOfSearchMatrixCareHomeHealthOrganizations200Response(value: object): value is SearchMatrixCareHomeHealthOrganizations200Response {
    return true;
}

export function SearchMatrixCareHomeHealthOrganizations200ResponseFromJSON(json: any): SearchMatrixCareHomeHealthOrganizations200Response {
    return SearchMatrixCareHomeHealthOrganizations200ResponseFromJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthOrganizations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMatrixCareHomeHealthOrganizations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(MatrixCareLookupItemFromJSON)),
    };
}

export function SearchMatrixCareHomeHealthOrganizations200ResponseToJSON(json: any): SearchMatrixCareHomeHealthOrganizations200Response {
    return SearchMatrixCareHomeHealthOrganizations200ResponseToJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthOrganizations200ResponseToJSONTyped(value?: SearchMatrixCareHomeHealthOrganizations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(MatrixCareLookupItemToJSON)),
    };
}

